"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfPlatformAdminDto = instanceOfPlatformAdminDto;
exports.PlatformAdminDtoFromJSON = PlatformAdminDtoFromJSON;
exports.PlatformAdminDtoFromJSONTyped = PlatformAdminDtoFromJSONTyped;
exports.PlatformAdminDtoToJSON = PlatformAdminDtoToJSON;
exports.PlatformAdminDtoToJSONTyped = PlatformAdminDtoToJSONTyped;
/**
 * Check if a given object implements the PlatformAdminDto interface.
 */
function instanceOfPlatformAdminDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('firstName' in value) || value['firstName'] === undefined)
        return false;
    if (!('lastName' in value) || value['lastName'] === undefined)
        return false;
    if (!('email' in value) || value['email'] === undefined)
        return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined)
        return false;
    if (!('auth0UserId' in value) || value['auth0UserId'] === undefined)
        return false;
    return true;
}
function PlatformAdminDtoFromJSON(json) {
    return PlatformAdminDtoFromJSONTyped(json, false);
}
function PlatformAdminDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'email': json['email'],
        'createdAt': (new Date(json['createdAt'])),
        'auth0UserId': json['auth0UserId'],
    };
}
function PlatformAdminDtoToJSON(json) {
    return PlatformAdminDtoToJSONTyped(json, false);
}
function PlatformAdminDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'email': value['email'],
        'createdAt': ((value['createdAt']).toISOString().substring(0, 10)),
        'auth0UserId': value['auth0UserId'],
    };
}
//# sourceMappingURL=PlatformAdminDto.js.map